export default __webpack_public_path__ + "static/media/KRILL-USDC.76148336.png";